import { SettingOutlined } from "@ant-design/icons";
import ChevronDown from "@untitled-ui/icons-react/build/esm/ChevronDown";
import {
  Card,
  Col,
  Collapse,
  Divider,
  Dropdown,
  Form,
  Row,
  Spin,
  Typography,
} from "antd";
import React, { useState } from "react";
import { connect } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import {
  AccountFacility,
  handleTreasuryBillContractActionButtons,
} from "../../../../components/facilities/TreasuryFacility";
import MainLayout from "../../../../components/layouts/enhancement/MainLayout";
import TopContent from "../../../../components/layouts/enhancement/TopContent";
import cnt from "../../../../services/definedConstant";
import { BOM } from "../../../../services/definedMethod";
import { Util } from "../../../treasury/treasuryBill/helper/helper";
import {
  useGetProdTemplate,
  useGetTreasuryItem,
} from "../../../treasury/treasuryBill/hooks/useServerActions";
import {
  apiConfig,
  labelConfig,
  staticConfig,
} from "../../contractbooking.config";
import {
  useGetCustomer,
  useGetTreasuryBillContract,
} from "../../hooks/useServerActions";
import PreviewTable from "./components/PreviewTable";
import TransactionsTab from "./components/TransactionsTab";
const { Panel } = Collapse;
const { Text, Link, Title, Paragraph } = Typography;

function ViewTreasuryBill(props) {
  const { userData } = props;
  const { session } = userData;
  const navigate = useNavigate();
  const { state } = useLocation();
  const [menuProps, setMenuProps] = useState({ items: [] });
  const [isLoading, setIsLoading] = useState(false);
  const { prodTemplate } = useGetProdTemplate(session);
  const [transactionsList, setTransactionsList] = useState([]);
  const [activeTabKey, setActiveTabKey] = useState("transactions");

  const {
    loading: contractLoading,
    contract,
    refetch,
  } = useGetTreasuryBillContract(session, state?.key);

  const [showInterestChecked, setShowInterestChecked] = useState(false);
  const { loading: customerLoading, data: customer } = useGetCustomer(
    session,
    contract?.client?.id
  );
  const { loading, treasuryBillItem } = useGetTreasuryItem(
    session,
    contract?.product?.id
  );
  console.log(state, "state");
  const maturityDate = BOM.DateTime(contract?.valueDate, "only-date") ?? "--";

  React.useEffect(() => {
    setMenuProps({
      items: handleTreasuryBillContractActionButtons(contract),
      onClick: (e) => {
        console.log(e);

        const item = handleTreasuryBillContractActionButtons(contract).find(
          (element) => element.key === e.key
        );
        if (item) {
          switch (item?.label.toLowerCase()) {
            case "activate":
              return activateContract();
            case "disable":
              return disableContract();

            default:
              //ROUTE REDIRECTING ACTIONS
              return navigate(item.route, {
                state: {
                  ...state,
                  actionLabel: item.label,
                  // branchId: temp.officeId,
                },
              });
          }
        }
      },
    });
  }, [contract]);
  const symbol = Util.getSymbol(prodTemplate, treasuryBillItem);
  console.log(treasuryBillItem, contract, "treasuryBillItem");
  function goBack() {
    props.setActivePage(props.activePage - 1);
  }
  console.log(contract);
  const dataSections = [
    {
      header: "Contract information",
      items: [
        { name: "Customer Name", labelValue: customer?.displayName, type: 1 },
        { name: "Customer ID", labelValue: customer?.accountNo, type: 1 },
        {
          name: "Customer Type",
          labelValue: customer?.legalForm?.value,
          type: 1,
        },
        { name: "Customer Branch", labelValue: customer?.officeName, type: 1 },
        {
          name: "Product Name",
          labelValue: treasuryBillItem?.productName,
          type: 1,
        },
        {
          name: "Custodian",
          labelValue: treasuryBillItem?.custodian?.name,
          type: 1,
        },
        {
          name: "Account Linked",
          // labelValue: `${contract?.linkedAccount?.savingsProductName} ${  contract?.linkedAccount?.accountNo}`,
          labelValue: `${contract?.linkedAccount?.savingsProductName} `,
        },
        // { name: "Initiated By", labelValue: "Mathew Ola", type: 1 },
      ],
    },
    {
      header: "Instrument Details",
      items: [
        {
          name: "Instrument",
          labelValue: treasuryBillItem?.instrumentType?.name,
        },
        {
          name: "Issuing Authority",
          labelValue: treasuryBillItem?.issuer?.name,
        },
        {
          name: "Auction Reference",
          labelValue: contract?.auctionReference,
          type: 1,
        },
        {
          name: "Maturity Tenor",
          labelValue: contract?.tenor,
        },
        {
          name: "Issue Date",
          labelValue: BOM.DateTime(contract?.issueDate, "only-date"),
          type: 1,
        },
        {
          name: "Maturity Date",
          labelValue: BOM.DateTime(contract?.valueDate, "only-date"),
          type: 1,
        },
      ],
    },
    {
      header: "Investment Details",
      items: [
        {
          name: "Face Value",
          labelValue: Number(contract?.faceValue).toLocaleString(),
          type: 1,
        },
        {
          name: "Discount Rate",
          labelValue: `${contract?.discountRate} %`,
          type: 1,
        },
        {
          name: "Purchase Price",
          labelValue: Number(contract?.purchasePrice)?.toLocaleString(),
          type: 1,
        },
        {
          name: "Yield",
          labelValue: Number(contract?.yieldPercentage)?.toLocaleString(),
          type: 1,
        },
        {
          name: "Interest Type",
          labelValue: treasuryBillItem?.interestType?.text,
        },
        {
          name: "Maturity Value",
          labelValue: Number(contract?.maturityValue)?.toLocaleString(),
          type: 1,
        },
        {
          name: "Settlement Date",
          labelValue: BOM.DateTime(contract?.settlementDate, "only-date"),
          type: 1,
        },
        {
          name: "Value Date",
          labelValue: BOM.DateTime(contract?.valueDate, "only-date"),
          type: 1,
        },
      ],
    },
    {
      header: "Tax & Regulatory",
      items: [
        {
          name: "Central Bank Reporting Code",
          labelValue: contract?.centralBankReportingCode,
          type: 1,
        },

        {
          name: "AML Flag",
          labelValue: contract?.amlScreening?.text,
        },

        {
          name: "Withholding Tax Allowed",
          type: 2,
          labelValue: contract?.withholdTax,
        },
        {
          name: "KYC/KYB Validated",
          type: 2,
          labelValue: contract?.kycValidated,
        },
        {
          name: "Central Bank Auction Reference Linked",
          type: 2,
          labelValue: contract?.centralBankAuctionRefLinked,
        },
      ],
    },
    {
      header: "Maturity Settings",
      items: [
        {
          name: "Target Account",
          labelValue: `${contract?.targetAccount?.savingsProductName}`,
          // labelValue: `${contract?.targetAccount?.savingsProductName} ${contract?.targetAccount?.accountNo}`,
        },
        {
          name: "Narration on Maturity",
          labelValue: contract?.maturityNarration,
          type: 1,
        },
        // {
        //   name: "Interest Rate Type",
        //   labelValue: product?.interestRateType?.text ?? "----",
        // },
        {
          name: "Interest Accrual",
          labelValue: contract?.interestType?.text,
        },
        {
          name: "Re-investment Option",
          type: 3,
          items: [
            {
              labelValue: contract?.allowRollover ? "Yes" : "No",
            },
            contract?.allowRollover
              ? {
                  labelValue:
                    contract?.autoRollover === false ? "Manual" : "Auto",
                }
              : null,
          ],
        },

        {
          name: "Withholding Tax Allowed",
          type: 2,
          labelValue: contract?.autoMaturityTransfer,
        },
      ],
    },
  ];

  function activateContract() {
    setIsLoading(true);
    const params = {
      command: "activate",
    };

    const url = `${apiConfig.GetTreasuryBillContract}/${state}/modify-status?`;

    const body = {
      method: "POST",
      session,
      params,
    };

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.defaultUserMessage);
        setIsLoading(false);
      } else {
        BOM.AlertMsg(cnt.SUCCESS, "Product Activated succesfully");
        //STOP LOAD

        refetch();

        setIsLoading(false);
      }
    });
  }

  const tabList = [
    {
      key: "transactions",
      label: "Transactions",
    },
  ];
  const contentListNoTitle = {
    transactions: (
      <TransactionsTab
        showInterestChecked={showInterestChecked}
        setShowInterestChecked={setShowInterestChecked}
        transactionsList={transactionsList}
        state={state}
        userData={userData}
      />
    ),
  };

  const onTabChange = (key) => {
    setActiveTabKey(key);
  };
  function disableContract() {
    setIsLoading(true);
    const params = {
      command: "disable",
    };
    const url = `${apiConfig.GetTreasuryBillContract}/${state}/modify-status?`;

    const body = {
      method: "POST",
      session,
      params,
    };

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.defaultUserMessage);
        setIsLoading(false);
      } else {
        BOM.AlertMsg(cnt.SUCCESS, "Product Disabled succesfully");
        //STOP LOAD
        refetch();

        setIsLoading(false);
      }
    });
  }
  function closeContract() {
    console.log("Closing..");

    setIsLoading(true);
    // const params = {
    //   command: "close",
    // };
    const url = `${apiConfig.GetTreasuryBillContract}/${state.key}/close`;

    const body = {
      method: "POST",
      session,
      // params,
    };

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.defaultUserMessage);
        setIsLoading(false);
      } else {
        BOM.AlertMsg(cnt.SUCCESS, "Contract Closed succesfully");
        //STOP LOAD
        refetch();

        setIsLoading(false);
      }
    });
  }

  function rejectContract() {
    console.log("Closing..");

    setIsLoading(true);
    // const params = {
    //   command: "close",
    // };
    const url = `${apiConfig.GetTreasuryBillContract}/${state.id}/reject`;

    const body = {
      method: "POST",
      session,
      // params,
    };

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.defaultUserMessage);
        setIsLoading(false);
      } else {
        BOM.AlertMsg(cnt.SUCCESS, "Contract Rejected succesfully");
        //STOP LOAD
        refetch();

        setIsLoading(false);
      }
    });
  }
  function undoApproval() {
    console.log("Closing..");

    setIsLoading(true);
    // const params = {
    //   command: "close",
    // };
    const url = `${apiConfig.GetTreasuryBillContract}/${state.key}/undoApproval`;

    const body = {
      method: "POST",
      session,
      // params,
    };

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.defaultUserMessage);
        setIsLoading(false);
      } else {
        BOM.AlertMsg(cnt.SUCCESS, "Undo approval succesfully");
        //STOP LOAD
        refetch();

        setIsLoading(false);
      }
    });
  }
  function getTransactionList() {
    console.log("Closing..");

    setIsLoading(true);
    // const params = {
    //   command: "close",
    // };
    const url = `${apiConfig.GetTreasuryBillContract}/${state.key}/transactions`;

    const body = {
      method: "GET",
      session,
      // params,
    };

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        console.log(err);
        BOM.AlertMsg(cnt.DANGER, err?.defaultUserMessage);
        setIsLoading(false);
      } else {
        console.log(res, "transaction list");
        setTransactionsList(
          res?.map((item, i) => ({
            id: item?.id,
            transactionDate: BOM.DateTime(item?.dateOf, "only-date") || "-",
            transactionType: BOM.Uwfirst(item?.transactionType.value),
            transactionTypeDetail: item?.transactionType?.value,
            amount: Number(item?.amount).toLocaleString(),
            currencyCode: item?.currency?.code,
            transactionRef: item?.refNo,
          }))
        );
        setIsLoading(false);
      }
    });
  }

  React.useEffect(() => {
    getTransactionList();
  }, []);

  return (
    <MainLayout
      // isEnableRightSidebar={true}
      // onView={handleOnView}
      // onAdd={handleOnCreate}
      // onEdit={handleOnEdit}
      pageItems={staticConfig.viewContractbookingTreasuryBill}
    >
      <TopContent
        pageTitle={labelConfig.treasuryBill}
        createPageTitle={"Treasury Bill Detail"}
        // pageItems={staticConfig.manageBreadcrumbItems}
      />
      <Spin
        spinning={loading || contractLoading || customerLoading}
        size="large"
      >
        {state && (
          <>
            <Card
              headStyle={{ borderBottomWidth: 0 }}
              style={{
                boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
                borderRadius: 20,
                marginTop: 20,
              }}
            >
              <Form
                // form={useForm}
                layout="vertical"
                style={{ paddingTop: 20, marginBottom: 50 }}
              >
                <Row>
                  <Title level={4} style={{ margin: 0, marginBottom: 0 }}>
                    {labelConfig.generalInfo}
                  </Title>
                </Row>
                <Divider style={{ marginTop: 10 }} />
                <Row>
                  <Col span={12} style={{ padding: "0px 8px" }}>
                    <Dropdown.Button
                      menu={menuProps}
                      icon={<SettingOutlined />}
                      placement="topLeft"
                    >
                      Actions
                    </Dropdown.Button>
                  </Col>

                  {/* <Col span={12} style={{ padding: "0px 8px" }}>
                    <ProductFacility displayName={contract?.client?.displayName} contractId={contract?.contractReferenceId} status={contract?.status.text} />
                  </Col> */}
                </Row>
                <AccountFacility
                  status={contract?.status?.text}
                  name={contract?.client?.displayName}
                  id={contract?.contractReferenceId}
                  amount={contract?.faceValue}
                  interest={contract?.totalInterestAccrued}
                  currencyCode={contract?.currency?.code}
                  interestPerAnnum={contract?.discountRate}
                  maturityDate={maturityDate}
                />

                <Row
                  style={{
                    display: "grid",
                    gridTemplateColumns: "1fr 1fr",
                    gap: 20,
                  }}
                >
                  {dataSections.map((item, i) => {
                    return (
                      <Col style={{}}>
                        <Collapse
                          className="custom-collapse"
                          // expandIconPosition="start"
                          expandIcon={<ChevronDown color="red" />}
                          style={{
                            backgroundColor: "transparent",
                            padding: 0,
                          }}
                        >
                          <Panel
                            header={
                              <span
                                style={{
                                  fontSize: "16px",
                                  fontWeight: 500,
                                }}
                              >
                                {item.header}
                              </span>
                            }
                            style={{
                              borderRadius: "8px",
                              overflow: "hidden",
                            }}
                            key={i}
                          >
                            <PreviewTable data={item.items} />
                          </Panel>
                        </Collapse>
                      </Col>
                    );
                  })}
                </Row>
              </Form>
            </Card>
            <Card
              className="custom-transaction-tab"
              headStyle={{ borderBottomWidth: 0 }}
              style={{
                width: "100%",
                boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
                borderRadius: 20,
                marginTop: 24,
              }}
              tabList={tabList}
              activeTabKey={activeTabKey}
              onTabChange={onTabChange}
              tabProps={{
                size: "middle",
              }}
            >
              {contentListNoTitle[activeTabKey]}
            </Card>
          </>
        )}
        {!state && (
          <Card
            headStyle={{ borderBottomWidth: 0 }}
            style={{
              // boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
              borderRadius: 20,
              marginTop: 20,
            }}
          >
            <Text>No data</Text>
          </Card>
        )}
      </Spin>
    </MainLayout>
  );
}

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
  rightBtn: state.RightSideBtn,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(ViewTreasuryBill);
// Matured
